import React, { Component } from "react";
import OtpInput from "react-otp-input";
import { withStyles } from "@mui/styles";
import { renderOTPTimer } from "../../helpers/utils";
import { Box, Button, Typography } from "@mui/material";

const useStyles = (theme) => ({
  inputStyle: {
    width: theme.spacing(3) + " !important",
    height: theme.spacing(3),
    margin: theme.spacing(1),
    fontSize: "16px",
    borderRadius: theme.spacing(0.75),
    borderWidth: "2px",
    borderColor: "#000000",
    boxShadow: "inset 1px 2px 8px 1px rgba(0, 0, 0, 0.11)",
    // borderColor: "#ffd900", //"rgba(0, 0, 0, 0.11)",
    // boxShadow: "inset 1px 2px 4px 1px rgba(0, 0, 0, 0.11)",
    // backgroundColor: "#ecf0f4",
  },
  customBtn: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between",
      flexDirection: "row-reverse",
    },
    [theme.breakpoints.up("md")]: {
      justifyContent: "space-between",
      flexDirection: "row-reverse",
    },
  },
  customMobileBtn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  otpMessage: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "start",
    },
  },
  seconds: {
    padding: "14px 0",
    width: theme.spacing(10),
    textAlign: "center",
  },
  changeNumberBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  changeNumber: {
    color: theme.palette.secondary.main,
    padding: theme.spacing(0, 0, 0, 2),
  },
  otpInputs: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
});

class CustomOtpInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: props.otp ?? "",
      numInputs: 6,
      separator: " ",
      isDisabled: false,
      hasErrored: false,
      isInputNum: true,
      isDesktop: window.innerWidth > 600,
      time: {},
      seconds: 90,
      disabled: props?.disabled ?? false,
    };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  handleOtpChange = (otp) => {
    otp = otp.replace(/[^0-9]+/g, "");

    this.setState({ otp: otp }, () => {
      this.props.otpCallBack(otp);
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    alert(this.state.otp);
  };

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  startTimer() {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.setState({
        disabled: true,
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    if (seconds === 0) {
      clearInterval(this.timer);
      this.setState({
        disabled: false,
        seconds: 90,
      });
      this.timer = 0;
    }
  }

  componentWillMount = () => {
    this.startTimer();
    // !this.props?.errors?.length && this.startTimer();
    this.setState({ otp: "" });
  };

  render() {
    // const isDesktop = this.state.isDesktop;
    const { otp, numInputs, separator, isDisabled, hasErrored, isInputNum } =
      this.state;
    const { classes, resend = true, buttonText = "Resend OTP" } = this.props;
    return (
      <Box
        display="flex"
        justifyContent="center"
        textAlign={"center"}
        alignItems={"center"}
        sx={{ width: "100%" }}
      >
        <Box>
          <Box flexDirection={"column"}>
            <Box className={classes.otpInputs}>
              <OtpInput
                inputStyle={classes.inputStyle}
                numInputs={numInputs}
                isDisabled={isDisabled || this.props.isFormSubmitted}
                hasErrored={hasErrored}
                errorStyle="error"
                onChange={this.handleOtpChange}
                renderSeparator={<span>{separator}</span>}
                isInputNum={isInputNum}
                shouldAutoFocus
                value={otp}
                renderInput={(props) => (
                  <input
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    {...props}
                  />
                )}
              />
            </Box>

            {resend === true && (
              <Box
                mt={0.5}
                display={"flex"}
                justifyContent={"center"}
                width={"100%"}
                alignItems={"center"}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={(e) => {
                    this.startTimer();
                    this.props.resendOtp();
                  }}
                  disabled={this.state.disabled}
                  fullWidth
                  sx={{ lineHeight: 1.25 }}
                >
                  {`${buttonText} ${
                    this.state.disabled
                      ? "After " + renderOTPTimer(this.state.seconds)
                      : ""
                  }`}
                </Button>

                {this.props.changeNumber && 1 === 2 && (
                  <Box
                    className={classes.changeNumberBox}
                    onClick={(e) => {
                      this.props.onChangeNumberClick(0);
                    }}
                  >
                    <Typography
                      variant={"caption"}
                      className={classes.changeNumber}
                    >
                      <u>CHANGE NUMBER</u>
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(CustomOtpInput);
